import { Metamodel } from '../../base/model';
import { GoogleCloudStorageLocation } from './google-cloud-storage.location';
import { SapDatasphereForGoogleCloudStorageLinkedService } from '../../linkedservice/sap-datasphere-for-google-cloud-storage.linkedservice';

@Metamodel.model({
    name: 'SapDatasphereForGoogleCloudStorageLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForGoogleCloudStorageLinkedService)
    }
})
export class SapDatasphereForGoogleCloudStorageLocation extends GoogleCloudStorageLocation {}
